import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { ShoppingBag, KeyRound } from 'lucide-react';
import api from '../lib/api';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSendCode = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setStep(2);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao enviar código');
    }
    setLoading(false);
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) { setError('Senha deve ter no mínimo 6 caracteres'); return; }
    setError(''); setLoading(true);
    try {
      await api.post('/auth/reset-password', { email, code, new_password: newPassword });
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.detail || 'Código inválido ou expirado');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
            <KeyRound className="h-8 w-8 text-primary" />
          </div>
          <h1 className="text-2xl font-bold tracking-tight" style={{ fontFamily: 'Outfit' }}>Recuperar Senha</h1>
          <p className="text-sm text-muted-foreground mt-1">
            {step === 1 ? 'Informe seu email para receber o código' : 'Digite o código e a nova senha'}
          </p>
        </div>

        {step === 1 ? (
          <form onSubmit={handleSendCode} className="space-y-4" data-testid="forgot-form">
            {error && <div className="p-3 rounded-lg bg-destructive/10 text-destructive text-sm">{error}</div>}
            <div className="space-y-2">
              <Label>Email</Label>
              <Input type="email" placeholder="seu@email.com" value={email} onChange={e => setEmail(e.target.value)} required data-testid="forgot-email-input" />
            </div>
            <Button type="submit" className="w-full rounded-lg" disabled={loading} data-testid="forgot-submit-btn">
              {loading ? 'Enviando...' : 'Enviar Código'}
            </Button>
          </form>
        ) : (
          <form onSubmit={handleReset} className="space-y-4" data-testid="reset-form">
            {error && <div className="p-3 rounded-lg bg-destructive/10 text-destructive text-sm">{error}</div>}
            <div className="space-y-2">
              <Label>Código de 6 dígitos</Label>
              <Input type="text" placeholder="000000" value={code} onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))} className="text-center text-2xl tracking-[0.5em] font-mono" maxLength={6} required data-testid="reset-code-input" />
            </div>
            <div className="space-y-2">
              <Label>Nova Senha</Label>
              <Input type="password" placeholder="Mínimo 6 caracteres" value={newPassword} onChange={e => setNewPassword(e.target.value)} required data-testid="reset-password-input" />
            </div>
            <Button type="submit" className="w-full rounded-lg" disabled={loading} data-testid="reset-submit-btn">
              {loading ? 'Alterando...' : 'Alterar Senha'}
            </Button>
          </form>
        )}

        <p className="text-center text-sm text-muted-foreground mt-6">
          <Link to="/login" className="text-primary hover:underline">Voltar para login</Link>
        </p>
      </div>
    </div>
  );
}
